
<div class="circle " [ngClass]="{ 'accent-background-element' :fillColor,'centred' :showName,'accent-border-element':!fillColor}" [matTooltip]="fullName" matTooltipPosition="below" [matTooltipDisabled]='showName'>
  <div class="initials" [ngClass]="{ 'contrast-to-primary-text' :fillColor,'accent-text-element':!fillColor}">
    <span>{{initials}}</span>

  </div>
</div>

@if (showName) {
  <div class="mat-small name">{{fullName}}</div>
}